export default {
    computed:{
        girartegundName(){
            if(typeof  this.lib.girartegund !== "object"){
                return null
            }
            let type = this.lib.girartegund.filter(type => +this.car.girartegund === type.id)[0];
            if(type){
                return type.name;
            }
        },
        drifName(){
            if(typeof  this.lib.girartegund !== "object"){
                return null
            }
            let type = this.lib.drif.filter(type => +this.car.drif === type.id)[0];
            if(type){
                return type.name;
            }
            return '';
        },
        colorName(){
            if(typeof  this.lib.girartegund !== "object"){
                return null
            }
            let type = this.lib.color.filter(type => +this.car.litur === type.id)[0];
            if(type){
                return type.name;
            }
            return '';
        }
    }
}